export default __webpack_public_path__ + "static/media/NeueHaasUnicaW02-Regular.6d428348.woff";